import Controller from '@ember/controller';
import { action, computed, get, set } from '@ember/object';
import { service } from '@ember/service';

export default Controller.extend({
  router: service(),

  invalidFileExtension: computed('model.selectedFile', function () {
    let selectedFile = get(this, 'model.selectedFile');
    if (selectedFile) {
      // had to add tntdatasync\.txt for Wycliffe Canada. For some reason they add that
      return (
        /\.(tntdatasync|tntmpd|tntconnect|tntdatasync\.txt)$/.test(
          selectedFile.name,
        ) === false
      );
    } else {
      return false;
    }
  }),

  handleFileSelected: action(function (file) {
    set(this, 'model.selectedFile', file);
    if (!this.invalidFileExtension) {
      this.router.transitionTo(
        'funds.fund.more.tnt-connect-import.data-sync.processing',
      );
    }
  }),
});
